<!-- Dashboard Header Card -->
@if (dashboardConfig$ | async; as dashboardConfig) {
  <div class="dashboard-header">
    <mat-card class="background-accent">
      <mat-card-header>
        <mat-card-title>
          <div class="header-title mat-headline-6">
            {{ dashboardConfig.title }}
          </div>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (dashboardConfig.image) {
          <img class="header-image" [src]="dashboardConfig.image" />
        }
        <div class="mat-body-1">
          @if (dashboardConfig.useMarkdown) {
            <div [innerHtml]="dashboardConfig.message | markdown"></div>
          } @else {
            <div class="header-message">{{ dashboardConfig.message }}</div>
          }
        </div>
        <div class="clear"></div>
      </mat-card-content>
      @if (isGuest) {
        <mat-card-footer>
          <div class="header-credit">
            {{ 'POWERED_BY_GLOBALSEARCH' | transloco }}
          </div>
        </mat-card-footer>
      }
    </mat-card>
  </div>
}
@if (searches$ | async; as searches) {
  <!-- Search Filter -->
  @if (searches.length > 4) {
    <mat-form-field appearance="outline" class="search-filter">
      <input
        matInput
        placeholder="{{
          (dashboardConfig$ | async)?.filterLabel ??
            ('FILTER_SEARCHES' | transloco)
        }}"
        [(ngModel)]="searchFilter"
      />
      <button
        aria-label="Clear Search Filter"
        mat-icon-button
        matSuffix
        (click)="searchFilter = ''"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </mat-form-field>
  }
  <!-- Card Grid -->
  <div class="card-flow fill">
    <mat-grid-list #grid rowHeight="82px" [cols]="gridCols">
      @for (
        search of searches | filterName: searchFilter | orderBy: 'name' : 'asc';
        track search
      ) {
        <mat-grid-tile>
          <mat-card
            class="search-card"
            mat-ripple
            (click)="
              onSearchClick(
                $event,
                search,
                search.settings.dashboardSearchShouldAlwaysPrompt
              )
            "
            [matTooltip]="
              search.name +
              (search.description ? ': ' + search.description : '')
            "
            matTooltipShowDelay="700"
          >
            <mat-card-content>
              <mat-icon>{{ search.icon }}</mat-icon>
              <span class="search-card-label">{{ search.name }}</span>
            </mat-card-content>
            <mat-card-subtitle>{{ search.description }}</mat-card-subtitle>
            @if (!search.settings.dashboardSearchShouldAlwaysPrompt) {
              <button
                title="{{ 'ADVANCED' | transloco }}"
                mat-icon-button
                class="search-with-properties top-right-corner"
                (click)="onSearchClick($event, search, true)"
              >
                <mat-icon>tune</mat-icon>
              </button>
            }
          </mat-card>
        </mat-grid-tile>
      }
    </mat-grid-list>
    <div class="logo-container">
      <app-logo-svg logo-size="256" monochrome></app-logo-svg>
    </div>
  </div>
}
